import { useState } from "react";
import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";
import ConfigUtils from "../utils/Config";

// País por defecto para interpretar un teléfono sin prefijo: el de la clínica configurada,
// no siempre España. Se usa en cada llamada (no en un valor por defecto fijo) porque puede
// cambiar durante la sesión.
const getClinicCountryCode = (): CountryCode => {
  return (ConfigUtils.getPais() as CountryCode) || "ES";
};

export const usePhoneInput = (defaultCountry: CountryCode = getClinicCountryCode()) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  const getPhoneNumber = () => {
    if (!value) return null;

    return parsePhoneNumberFromString(value, defaultCountry);
  };

  const validate = () => {
    const phoneNumber = getPhoneNumber();

    const isValid = !!phoneNumber && phoneNumber.isValid();

    setError(!isValid);
    return isValid;
  };

  const getNormalized = () => {
    const phoneNumber = getPhoneNumber();

    return phoneNumber?.number || "";
  };

  const reset = (newValue: string = "") => {
    setValue(newValue);
    setError(false);
  };

  return {
    value,
    setValue,
    error,
    validate,
    reset,
    normalized: getNormalized(),
  };
};

export const formatPhoneForDisplay = (phone: string) => {
  if (!phone) return '';
  let parsed = parsePhoneNumberFromString(phone);
  if (!parsed) {
    parsed = parsePhoneNumberFromString(phone, getClinicCountryCode());
  }
  return parsed?.formatInternational() || phone;
};

export const getTelHref = (phone: string) => {
  if (!phone) return '#';
  let parsed = parsePhoneNumberFromString(phone);
  if (!parsed) {
    parsed = parsePhoneNumberFromString(phone, getClinicCountryCode());
  }
  return parsed?.number ? `tel:${parsed.number}` : `tel:${phone}`;
};